import React from "react";
import Modal from "react-modal";
import { CloseButton } from "../CloseButton";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%,-50%)",
  },
};

interface ModalElementProps {
  children: React.ReactNode;
  closeModal: () => void;
  isOpen: boolean;
}

Modal.setAppElement("#root");

const ModalElement = ({ children, closeModal, isOpen }: ModalElementProps) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Modal"
      >
        <div style={{ position: "relative" }}>
          <div
            style={{ position: "absolute", top: "-1.3rem", right: "-1.3rem" }}
          >
            <CloseButton closeModal={closeModal} />
          </div>
          {children}
        </div>
      </Modal>
    </div>
  );
};

export default ModalElement;
